module.exports = __webpack_public_path__ + "static/media/restful-api.137f9437.svg";